import { useTranslation } from "react-i18next";

import { getColorByRadioValue } from "../../utils/helpers";

import { Attribute, FingerPrintJSValue, Ratio } from "../../components";
import Cell from "../../components/common/AccordionTable/components/Cell";
import { DividerTableMenu } from "../../components/common/AccordionTable/components/DropdownTableMenu/components/DividerTableMenu";
import DropdownItem from "../../components/common/AccordionTable/components/DropdownTableMenu/components/DropdownItem";
import SpanStyled from "../../components/common/AccordionTable/components/Span";

export const useFingerprintJSAdapter = () => {
  const { t } = useTranslation();

  const headerData = [
    t("global.attribute"),
    t("global.similarityRatio"),
    t("global.value"),
  ];

  const getAttributeName = (item, ind) => {
    return `${ind + 1} - ${item.attribute}`;
  };

  const renderRowContent = (item, ind) => {
    return (
      <>
        <Cell>
          <Attribute tooltipText={item?.clue}>
            {getAttributeName(item, ind)}
          </Attribute>
        </Cell>
        <Cell>
          <Ratio colorSettings={getColorByRadioValue(item.ratio)}>
            {item.ratio} %
          </Ratio>
        </Cell>
        <Cell>
          <FingerPrintJSValue element={item.value} type={item.type} />
        </Cell>
      </>
    );
  };

  const renderHeaderTitle = (item, ind) => {
    return <Attribute>{getAttributeName(item, ind)}</Attribute>;
  };

  const renderDropdownContent = item => {
    return (
      <>
        <DropdownItem>
          <span>{headerData[1]}</span>
          <SpanStyled>
            {" "}
            <Ratio colorSettings={getColorByRadioValue(item.ratio)}>
              {item.ratio} %
            </Ratio>
          </SpanStyled>
        </DropdownItem>

        <DividerTableMenu />

        <DropdownItem>
          <span>{headerData[headerData.length - 1]} </span>
          <FingerPrintJSValue element={item.value} type={item.type} />
        </DropdownItem>
      </>
    );
  };

  return {
    renderRowContent,
    renderHeaderTitle,
    renderDropdownContent,
    headerData,
  };
};
